import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { hex2rgba } from '../../lib/utils';
import type { IBlockWithSignerNumber } from '../../store/applyTemplate/types';

const useStyles = makeStyles(() => ({
  block: {
    position: 'absolute',
    zIndex: 4,
  },
}));

interface IProps {
  block: IBlockWithSignerNumber;
  color: string;
  pageDimensions: { x: number; y: number };
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const BlockPreview = (props: IProps) => {
  const { block, color, pageDimensions } = props;
  const classes = useStyles();

  return (
    <div
      className={classes.block}
      style={{
        left: `${(block.x! / pageDimensions.x) * 100}%`,
        height: `${(block.height! / pageDimensions.y) * 100}%`,
        width: `${(block.width! / pageDimensions.x) * 100}%`,
        top: `${(block.y! / pageDimensions.y) * 100}%`,
        backgroundColor: hex2rgba(color),
        outline: `1px solid ${color}`,
      }}
    />
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default BlockPreview;
